import React from 'react';
import { CalendarCheck, LineChart, UserSearch } from 'lucide-react';
import Reveal from './Reveal';

const steps = [
  {
    icon: UserSearch,
    title: 'Tell us the goal',
    body: 'Subject, exam board, target grade and the bits that aren’t clicking. Two minutes, no call required.',
  },
  {
    icon: CalendarCheck,
    title: 'Meet your match',
    body: 'We shortlist tutors who have aced the exact same spec, then book a free intro lesson at a time that suits.',
  },
  {
    icon: LineChart,
    title: 'Watch it land',
    body: 'Every session leaves a recap, practice questions and a syllabus map showing exactly what’s been covered.',
  },
];

const HowItWorks: React.FC = () => (
  <section className="section-shell py-20 sm:py-28">
    <Reveal className="max-w-2xl">
      <p className="eyebrow">How it works</p>
      <h2 className="display mt-3 text-4xl text-balance sm:text-5xl">
        Three steps from stuck to
        {' '}
        <span className="italic text-brand-600 dark:text-brand-400">sorted</span>
      </h2>
    </Reveal>

    <div className="relative mt-14 grid gap-6 lg:grid-cols-3">
      {/* Connector rail behind the cards on wide screens */}
      <div
        aria-hidden="true"
        className="absolute left-0 right-0 top-[3.4rem] hidden h-px bg-gradient-to-r from-transparent via-ink-900/10 to-transparent lg:block dark:via-white/15"
      />

      {steps.map((step, i) => (
        <Reveal key={step.title} delay={i * 0.1}>
          <div className="surface group relative h-full p-7 shadow-soft transition duration-300 hover:-translate-y-1 hover:shadow-lift">
            <div className="flex items-center gap-4">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-xl bg-brand-600/10 text-brand-600 ring-1 ring-inset ring-brand-600/15 transition group-hover:bg-brand-600 group-hover:text-white dark:text-brand-400">
                <step.icon className="h-5 w-5" />
              </span>
              <span className="display text-3xl text-base-content/15">
                0
                {i + 1}
              </span>
            </div>
            <h3 className="mt-6 text-lg font-semibold">{step.title}</h3>
            <p className="mt-2.5 text-[15px] leading-relaxed text-base-content/60">{step.body}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);

export default HowItWorks;
